import React from 'react';
import Button, {RouterLinkButton} from '../button/button';
import {Link, useLocation} from 'react-router-dom';
import {useNavigate} from 'react-router-dom';
import Lock from '../../assets/icons0/lock-unlocked-01.svg';
import ArrowLeft from '../../assets/icons0/arrow-left.svg';
import MinusSvg from '../../assets/icons0/minus.svg';
import PlusSvg from '../../assets/icons0/plus.svg';
import Close from '../../assets/icons/x.svg';
import DotsVerticalSvg from '../../assets/icons/dots-vertical.svg';
import StepsBar from './steps-bar';
import moment from 'moment';
import PlusCircleIcon from '../../assets/icons0/plus-circle.svg';
import {useForm} from 'react-hook-form';
import useQuery from '../../utilities/use-query';
import {graphql, useLazyLoadQuery, useMutation} from 'react-relay/hooks';
import {graphqlOperatorInterfaceServiceByIdQuery} from './graphql';
import Redirect from '../redirect';
import searchFilter from '../../utilities/search-filter';
import {useOperatorDispatch, useOperatorState} from './operator-interface';
import getImageUrl from './get-image-url';
import {isNullOrUndefined} from '../../utilities/utility';
import i18n from '../../utilities/i18n';
import {FormattedMessage} from 'react-intl';
import useMountedState from '../../utilities/use-mounted-state';
import {FetchKeySetStateContext} from '../fetch-key';
import {useSettingsState} from '../settings';

const RAZZLE_GRECAPTCHA = process.env.RAZZLE_GRECAPTCHA;

const Step52 = React.memo(({selectedEndpointState, selected, updateEndpoint, removeEndpoint, isSaving}) => {
  const {defaultServiceId} = useSettingsState();
  const {serviceId = defaultServiceId, locale = 'uk'} = useQuery();
  const {serviceById} = useLazyLoadQuery(graphqlOperatorInterfaceServiceByIdQuery, {id: serviceId});
  const [quantity, setQuantity] = React.useState(selectedEndpointState.income || 0);
  // const img = getImageUrl(selected.details, selected.tags);
  const refPhoto = React.useRef();
  const refAct = React.useRef();
  const initalExpirationDate = selected.end;
  const expirationDate = !isNullOrUndefined(selectedEndpointState.income) ? selectedEndpointState.end : '';
  const {register, watch} = useForm({
    defaultValues: {
      date: expirationDate ? moment(expirationDate).format('YYYY-MM-DD') : ''
    }
  });
  const dateValue = watch('date');
  React.useEffect(() => {
    if (!refPhoto.current || !refAct.current) return;
    const photo = refPhoto.current.getBoundingClientRect();
    const act = refAct.current.getBoundingClientRect();
    refPhoto.current.style.height = `${window.innerHeight - photo.top - act.height}px`;
  }, [refAct, refPhoto]);

  const [apply, applying] = useMutation(
    graphql`
        mutation step52WebhookServiceQuery($request: WebhookServiceRequestInput) {
            webhookService(request: $request) {
                id
            }
        }
  `);
  const open = () => {
    apply({
        variables: {
            request: {
                id: serviceById.id,
                version: serviceById.version,
                event: 'service.open'
            }
        },
        onCompleted: () => {},
        onError: () => {}
    });
  };

  return (<>
    <div className='mm-header background-color-gray-50'>
      <div className='lock-button' onClick={() => !applying && open()}>
        <Lock className='display-block color-gray-500 height-1dot25rem'/>   
      </div>
      <StepsBar/>
      <Link to={`../step-4${searchFilter(location.search)}`}>
        <ArrowLeft className='display-block color-gray-500 height-1dot5rem'/>  
      </Link>
    </div>
    <div className='fulfill-title display-flex border-bottom justify-content-space-between align-items-center'>
      <div className='text-xl medium color-gray-900'>
        {!isNullOrUndefined(selectedEndpointState.income) ? <FormattedMessage defaultMessage='Edit'/> : <FormattedMessage defaultMessage='Add'/>} <FormattedMessage defaultMessage='position'/>
      </div>
      <div>
        <Link to={`../step-5${searchFilter(location.search)}`}>
          <Close className='height-2dot5rem width-2dot5rem padding-0dot625rem display-block color-gray-700'/> 
        </Link>
      </div>
    </div>
    <div className='display-flex flex-direction-column'>
      {/* <div className='padding-top-1dot5rem padding-left-1dot25rem padding-right-1dot25rem'>
        <div {...{ref: refPhoto}}>
            <img src={img || 'https://ticket.demo.impulse.ottry.com/mm/Frame12.jpg'} className='object-fit-contain width-100percent height-100percent'/>
        </div>
      </div> */}
      <div {...{ref: refAct}} className='padding-top-1dot5rem'>
        <div className='item-name-and-description'>
          <h2 className='color-gray-900 medium text-lg'>
            {i18n(selected, 'name', locale)}
          </h2>
          
            <div className='color-gray-500 regular text-sm margin-top-0dot25rem display-flex'>
              {(!!dateValue || !!initalExpirationDate) && <span className='padding-right-0dot375rem'><FormattedMessage defaultMessage='Expires'/></span>}
              <div className='position-relative'>
                {(!!dateValue || !!initalExpirationDate) && <span className='text-decoration-underline'>{dateValue ? moment(dateValue).format('DD-MM-YYYY') : moment(initalExpirationDate).format('DD-MM-YYYY')}</span>}
                {!dateValue && !initalExpirationDate && 
                  <div className='display-flex align-items-center'>
                    <PlusCircleIcon className='height-1dot25rem width-1dot25rem margin-right-0dot5rem'/>
                    <span><FormattedMessage defaultMessage='Add expiration date'/></span>
                  </div>
                }
                <input id='date' {...register('date')} className='opacity-0 position-absolute bottom-0 top-0 left-0 right-0 width-100percent input-date-hidden z-index-1' type='date'/>
              </div>
            </div>
          <DotsVerticalSvg className='more-button display-block color-gray-400 height-1dot25rem width-1dot25rem'/> 
        </div>
        <div className='button-block-padding'>
          <div className ='itemQuantitySelectorBlock display-flex'>
            <Button
              {...{ 
                size: 'xl',
                clickHandler: () => setQuantity(prev => prev <= 1 ? 1 : prev -1),
                isLoading: false,
                fluid: 'always',
                disabled: isSaving
              }}
            >
              <MinusSvg className='minus-icon'/> 
            </Button>
            <input id='filter'
              name='filter'
              type='text'
              value={quantity}
              onChange={() => setQuantity(quantity)}
              className='form-row__input color-gray-700 medium background-color-gray-50'
              placeholder=''
              readOnly
            />
            <Button
              {...{ 
                size: 'xl',
                clickHandler: () => setQuantity(prev => prev + 1),
                isLoading: false,
                fluid: 'always',
                disabled: isSaving
              }}
            >
              <PlusSvg className='minus-icon'/> 
            </Button>
          </div>
          <div className='grid-button-block'>
            <Button
              {...{
                color: 'white-gradient',
                size: 'md',
                clickHandler: () => setQuantity(prev => prev + 2),
                disabled: isSaving
              }}
            >
              +2
            </Button>
            <Button
              {...{
                color: 'white-gradient',
                size: 'md',
                clickHandler: () => setQuantity(prev => prev + 3),
                disabled: isSaving
              }}
            >
              +3
            </Button>
            <Button
              {...{
                color: 'white-gradient',
                size: 'md',
                clickHandler: () => setQuantity(prev => prev + 5),
                disabled: isSaving
              }}
            >
              +5
            </Button>
            <Button
              {...{
                color: 'white-gradient',
                size: 'md',
                clickHandler: () => setQuantity(prev => prev + 10),
                disabled: isSaving
              }}
            >
              +10
            </Button>
          </div>
          <div className='display-block margin-bottom-0dot75rem'>
            <Button
              {...{
                color: 'blue-gradient',
                size: 'xl',
                clickHandler: () => updateEndpoint({quantity, dateValue}),
                isLoading: isSaving,
                fluid: 'always',
                disabled: !quantity
              }}
            >
              {!isNullOrUndefined(selectedEndpointState.income) ? <FormattedMessage defaultMessage='Edit'/> : <FormattedMessage defaultMessage='Add'/>} <FormattedMessage defaultMessage='position'/>
            </Button>
          </div>
          {!isNullOrUndefined(selectedEndpointState.income) && 
            <div className='display-block margin-bottom-0dot75rem'>
              <Button
                {...{
                  color: 'secondary-error',
                  size: 'xl',
                  clickHandler: () => removeEndpoint({quantity, dateValue}),
                  isLoading: false,
                  disabled: isSaving,
                  fluid: 'always'
                }}
              >
                <FormattedMessage defaultMessage='Remove'/>
              </Button>
            </div>
          }
          <RouterLinkButton
            {...{
              size: 'xl',
              to: `../step-5${searchFilter(location.search)}`,
              isLoading: false,
              fluid: 'always',
              disabled: false,
              additionalClasses: 'cancelButton'
            }}
          >
            <span className='color-gray-500'><FormattedMessage defaultMessage='Cancel'/></span>
          </RouterLinkButton>
        </div>
      </div>
    </div>
  </>);
});

const Step52CatalogWrapper = () => {
  const {defaultServiceId} = useSettingsState();
  const {serviceId = defaultServiceId, catalogId, locale = 'uk'} = useQuery();
  const location = useLocation();
  const [grecaptcha, setGrecaptcha] = useMountedState(false);
  const fetchKeySetState = React.useContext(FetchKeySetStateContext);
  const {catalogById} = useLazyLoadQuery(
    graphql`
      query step52CatalogsQuery($catalogId: String, $serviceId: String) {
        catalogById(id: $catalogId) {
          id
          price
          name
          tags
          nameUk
          details
          detailsUk
          endpoints(serviceId: $serviceId) {
            id
            quantity
            tags
            name
            nameUk
            end
            version
          }
          version
        }
      }
    `,
    {catalogId, serviceId}
  );
  const selected = catalogById.endpoints.length > 0 ? catalogById.endpoints[0] : catalogById;
  if (!catalogId || !catalogById) {
    return <Redirect {...{to: `../step-5${searchFilter(location.search)}`, replace: true}}/>
  }
  const dispatch = useOperatorDispatch();
  const navigate = useNavigate();
  const state = useOperatorState()[serviceId];
  const selectedEndpointState = state.endpoints[selected.id] || {
    quantity: selected.quantity || 0,
    catalogId: catalogById.id
  };
  const [createEndpoint, creatingEndpoints] = useMutation(
    graphql`
      mutation step52CreateEndpointMutation($request: EndpointRequestInput) {
        createEndpoint(request: $request) {
          id
          quantity
          tags
          name
          nameUk
          end
          version
        }
      }
  `);
  const createEndpointForService = ({quantity, dateValue}) => {
    const tags = Object.keys(catalogById.tags).filter(e => e !== 'status').map((key) => `${key}:${catalogById.tags[key]}`);
    const request = {
      catalog: catalogById.id,
      price: catalogById.price,
      services: [serviceId],
      name: catalogById.name,
      nameUk: catalogById.nameUk,
      details: catalogById.details,
      detailsUk: catalogById.detailsUk,
      quantity: 0,
      tags
    };
    setGrecaptcha(true);
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(RAZZLE_GRECAPTCHA, {action: 'submit'}).then((token) => {
        createEndpoint({
          variables: {request: {
            ...request,
            reCaptcha: token
          }},
          onCompleted: (data) => {
            dispatch({
              type: 'update-endpoint',
              payload: {
                serviceId,
                endpoint: {
                  ...selectedEndpointState,
                  id: data.createEndpoint.id,
                  income: quantity,
                  end: dateValue ? moment(dateValue, 'YYYY-MM-DD').endOf('day').toISOString() : selected.end ? selected.end : null
                }
              }
            });
            fetchKeySetState((e) => e + 1);
            navigate(`../step-5${searchFilter(location.search)}`);
          },
          onError: () => {},
          updater: store => {
            const record = store.get(catalogById.id);
            if (record) {
                record.invalidateRecord();
            }
            const serviceRecord = store.get(serviceId);
            if (serviceRecord) {
              serviceRecord.invalidateRecord();
            }
          }
        });
        setGrecaptcha(false);
      });
    });
  };
  const updateEndpoint = ({quantity, dateValue}) => {
    if (catalogById.endpoints.length > 0) {
      dispatch({
        type: 'update-endpoint',
        payload: {
          serviceId,
          endpoint: {
            ...selectedEndpointState,
            id: catalogById.endpoints[0].id,
            income: quantity,
            end: dateValue ? moment(dateValue, 'YYYY-MM-DD').endOf('day').toISOString() : selected.end ? selected.end : null
          }
        }
      });
      navigate(`../step-5${searchFilter(location.search)}`);
    } else {
      createEndpointForService({quantity, dateValue});
    }
    
  };

  const removeEndpoint = ({quantity, dateValue}) => {
    dispatch({
      type: 'update-endpoint',
      payload: {
        serviceId,
        endpoint: {
          ...selectedEndpointState,
          id: catalogById.endpoints[0].id,
          income: null,
          end: selected && selected.end
        }
      }
    });
    navigate(`../step-5${searchFilter(location.search)}`);
  };

  return (
    <Step52 {...{selectedEndpointState, selected, updateEndpoint, removeEndpoint, isSaving: creatingEndpoints}}/>
  )
};

const Step52Wrapper = () => {
  const {defaultServiceId} = useSettingsState();
  const {serviceId = defaultServiceId, endpointId} = useQuery();
  const location = useLocation();
  const {serviceById} = useLazyLoadQuery(graphqlOperatorInterfaceServiceByIdQuery, {id: serviceId});
  const selected = serviceById.endpoints.find((item) => item.id == endpointId);
  if (!endpointId || !selected) {
    return <Redirect {...{to: `../step-5${searchFilter(location.search)}`, replace: true}}/>
  }
  const dispatch = useOperatorDispatch();
  const navigate = useNavigate();
  const state = useOperatorState()[serviceId];
  const selectedEndpointState = state.endpoints[selected.id] || {
    quantity: selected.quantity
  };
  const updateEndpoint = ({quantity, dateValue}) => {
    dispatch({
      type: 'update-endpoint',
      payload: {
        serviceId,
        endpoint: {
          ...selectedEndpointState,
          id: selected.id,
          income: quantity,
          end: dateValue ? moment(dateValue, 'YYYY-MM-DD').endOf('day').toISOString() : selected.end ? selected.end : null
        }
      }
    });
    navigate(`../step-5${searchFilter(location.search)}`);
  };

  const removeEndpoint = ({quantity, dateValue}) => {
    dispatch({
      type: 'update-endpoint',
      payload: {
        serviceId,
        endpoint: {
          ...selectedEndpointState,
          id: selected.id,
          income: null,
          end: selected && selected.end
        }
      }
    });
    navigate(`../step-5${searchFilter(location.search)}`);
  };

  return (
    <Step52 {...{selectedEndpointState, selected, updateEndpoint, removeEndpoint}}/>
  )
};

const Step52CatalogCheck = () => {
  const {catalogId} = useQuery();

  return (
    <>
      {!!catalogId
        ?
        <Step52CatalogWrapper/>
        :
        <Step52Wrapper/>
      }
    </>
  )
}

export default React.memo(Step52CatalogCheck);